import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Empty } from "antd";
import { SubObjectsAndData } from "./Pages/SubObjectsAndData";
import { ObjectsAndDataInfo } from "./Pages/ObjectsAndDataInfo";
import { ObjectsAndDataSearchResult } from "./Pages/ObjectsAndDataSearchResult";
import { Sidebar } from "./Components/Sidebar";
import { objectsAndDataStore } from "./Stores/ObjectsAndDataStore";
import { Loader } from "Components/General/Loader";
import { I18N_NS } from "Config/i18n";

const ObjectsAndDataStart = observer(() => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  if (objectsAndDataStore.initState !== 2) {
    return <Loader />;
  }

  if (objectsAndDataStore.state === "ERROR") {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("Failed to load object types")} />;
  }

  if (!objectsAndDataStore.data.length) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={t("No object types are defined for this project yet")}
      />
    );
  }

  // Object types exist, initialNavigate redirects to the first one.
  return <Loader />;
});

export const ObjectsAndData = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    (async () => {
      try {
        await objectsAndDataStore.init(navigate, location.pathname);
      } catch (error) {
        console.error("Failed to initialize Objects and data:", error);
      }
    })();
  }, [location]);

  return (
    <div className="documents-wrapper">
      <Sidebar {...props} />
      <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
        <Routes>
          <Route path={`:id`} element={<ObjectsAndDataInfo />} />
          <Route path={`:id/search-results`} element={<ObjectsAndDataSearchResult />} />
          <Route path={`:id/sub-object/:key`} element={<SubObjectsAndData />} />
          <Route path={`:id/sub-object/:key/:tab`} element={<SubObjectsAndData />} />
          <Route path={"/"} element={<ObjectsAndDataStart />} />
        </Routes>
      </div>
    </div>
  );
};
